import { differenceInMinutes, parseISO } from 'date-fns';
import { type OrderDetail } from '@hungryroot/rest/api/v2/customers/[id]/orders/[order_id]/get';

export const ONBOARDING_PROGRESS_LOCAL_STORAGE_KEY = 'onboarding-progress';

export enum OnboardingProgress {
  ShowCustomizeModal = 'show-customize-modal',
  ShowFirstPopover = 'show-first-popover',
  ShowSecondPopover = 'show-second-popover',
  CartWiggle = 'cart-wiggle',
}

const setOnboardingProgress = (nextStep: OnboardingProgress) =>
  localStorage.setItem(ONBOARDING_PROGRESS_LOCAL_STORAGE_KEY, nextStep);

const getOnboardingProgress = () =>
  localStorage.getItem(ONBOARDING_PROGRESS_LOCAL_STORAGE_KEY);

const deleteOnboardingProgress = () =>
  localStorage.removeItem(ONBOARDING_PROGRESS_LOCAL_STORAGE_KEY);

// This has a near-identical implementation to the onboarding package.
export function useOnboardingProgress(
  order: Pick<OrderDetail, 'cutoff_datetime' | 'sequence'> | undefined
) {
  if (order === undefined) {
    return undefined;
  }

  const cutoffDate = parseISO(order.cutoff_datetime);
  const now = new Date();
  const minutesUntilCutoff = differenceInMinutes(cutoffDate, now);

  if (minutesUntilCutoff < 0) {
    deleteOnboardingProgress();
    return undefined;
  }

  return {
    setOnboardingProgress,
    deleteOnboardingProgress,
    getOnboardingProgress,
  };
}
